import apiV2Service from '../api/api-v2.service';
import {ExcelColumnValuesResponse, ExcelWorksheet, RemoteExcelFile} from './excel.types';

const baseUrl = 'Excel';

async function readExcelFile({
  fileKey,
  rowsLimit,
  worksheetIndex = -1,
  omitTrailingEmptyRows = true,
}: {
  fileKey: string;
  rowsLimit?: number;
  worksheetIndex?: number;
  omitTrailingEmptyRows?: boolean;
}): Promise<ExcelWorksheet[]> {
  const url = `${baseUrl}/ReadExcel`;

  const {
    data: {worksheets},
  } = await apiV2Service.executePostRequest<RemoteExcelFile>(
    url,
    {},
    {
      s3FileKey: fileKey,
      worksheetIndex,
      omitTrailingEmptyRows,
      rowsLimit,
    },
  );

  return worksheets;
}

async function readColumnValuesFromExcelFile({
  fileKey,
  sheetName,
  columnsToReturn,
  lineRanges,
  returnDistinctRows = false,
  headerRowIndex,
}: {
  fileKey: string;
  sheetName: string;
  columnsToReturn: string[];
  lineRanges: {startLine?: number; endLine?: number}[];
  returnDistinctRows?: boolean;
  headerRowIndex?: number;
}): Promise<ExcelColumnValuesResponse> {
  const url = `${baseUrl}/GetColumnValues`;
  const {data} = await apiV2Service.executePostRequest<ExcelColumnValuesResponse>(
    url,
    {},
    {
      s3FileKey: fileKey,
      sheetName,
      columnsToReturn,
      lineRanges,
      returnDistinctRows,
      headerRowIndex,
    },
  );

  return data;
}

export const excelApi = {
  readExcelFile,
  readColumnValuesFromExcelFile,
};
